import { FcShape } from '@dtx-company/flowcode-generator-types/src'
import { FlowcodeShape } from './ShapeSelector.types'

export const shapeOptions: FlowcodeShape[] = [
  { shape: FcShape.CIRCLE, icon: '/icons/circle-shape.svg', label: 'Circle' },
  { shape: FcShape.SQUARE, icon: '/icons/square-shape.svg', label: 'Square' }
]
